import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import Spinner from '../Spinner/Spinner';
import { ComboboxLoadingStateMixin } from '../../mixins/components/ComboboxLoadingStateMixin';
export var StyledComboboxLoadingState = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledComboboxLoadingState",
  componentId: "c11n-8-64-0__sc-13p3c5x-0"
})(["", ""], ComboboxLoadingStateMixin);
var ComboboxLoadingState = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledComboboxLoadingState, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(Spinner, {
    size: "md"
  }));
});
ComboboxLoadingState.displayName = 'ComboboxLoadingState';
export default ComboboxLoadingState;